module.exports = __webpack_public_path__ + "img/inst-electrical.45d9d709.jpg";